'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCaption = exports.getCaption = function getCaption(element) {
  return element.getIn(['content', 'caption']);
};
var getShowCaption = exports.getShowCaption = function getShowCaption(element) {
  return element.getIn(['content', 'showCaption']);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/caption/elementCaptionUtil.js
// module id = 137
// module chunks = 0